module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/flatlays/flatlay-04-0a124e32ebb5f50e807e7470b69e19ad.webp";